import { Photo } from "@models/photo";

export enum AlbumType {
  Dynamic = "Dynamic",
  Static = "Static",
}

export interface AlbumPhoto {
  id: string;
  createdDate: string;
  photo: Photo;
}

export interface Album {
  id: string;
  createdDate: string;
  lastUpdatedDate: string;
  name: string;
  albumType: AlbumType;
  allPhotos: boolean;
  isHidden: boolean;
  photoCount: number;
  coverPhoto: Photo;
  photoIds?: string[];
  photos?: Photo[];
}
